/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_TitleInputs */

const en_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit History`)
};

const fr_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique des commits`)
};

const de_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit-Historie`)
};

const it_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronologia degli impegni`)
};

const ru_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`История коммитов`)
};

const es_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de confirmaciones`)
};

const zh_cn2_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交历史记录`)
};

const ja_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミット履歴`)
};

const hi_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिबद्धता इतिहास`)
};

const pt_pt2_snapshot_history_title = /** @type {(inputs: Snapshot_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico de Compromissos`)
};

/**
* | output |
* | --- |
* | "Commit History" |
*
* @param {Snapshot_History_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_title = /** @type {((inputs?: Snapshot_History_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_title(inputs)
	if (locale === "de") return de_snapshot_history_title(inputs)
	if (locale === "it") return it_snapshot_history_title(inputs)
	if (locale === "ru") return ru_snapshot_history_title(inputs)
	if (locale === "es") return es_snapshot_history_title(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_title(inputs)
	if (locale === "ja") return ja_snapshot_history_title(inputs)
	if (locale === "hi") return hi_snapshot_history_title(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_title(inputs)
	return en_snapshot_history_title(inputs)
});